import router from '@/router';

const OCRoutes = [
  {
    path: 'admin/operating_companies',
    name: 'OperatingCompany',
    component: {
      name: 'AdminOperatingCompany',
      render(h) {
        return h('router-view');
      },
    },
    meta: {
      resource: 'operating_company',
    },
    get redirect() {
      return this.children[0];
    },
    children: [
      {
        path: '',
        name: 'AdminOperatingCompanyIndex',
        component: () => import('../views/OperatingCompanyIndex.vue'),
        meta: {
          backRoute: { name: 'dashboard' },
        },
      },
      {
        path: 'new',
        name: 'AdminOperatingCompanyNew',
        component: () => import('../views/OperatingCompanyInput.vue'),
        meta: {
          action: 'new',
          backRoute: { name: 'AdminOperatingCompanyIndex' },
        },
      },
      {
        path: ':id(\\d+)',
        name: 'AdminOperatingCompanyShow',
        component: () => import('../views/OperatingCompanyShow.vue'),
        meta: {
          backRoute: {
            name: 'AdminOperatingCompanyIndex',
          },
          tArgs: route => ({ name: route?.params?.id }),
        },
        get redirect() {
          return this.children[0];
        },
        children: [
          {
            path: '',
            name: 'AdminOperatingCompanyDetails',
            component: () => import('../views/OperatingCompanyDetails.vue'),
            meta: {
              backRoute: { name: 'AdminOperatingCompanyIndex' },
            },
          },
          {
            path: 'edit',
            name: 'AdminOperatingCompanyEdit',
            component: () => import('../views/OperatingCompanyInput.vue'),
            meta: {
              action: 'edit',
              backRoute: { name: 'AdminOperatingCompanyDetails' },
            },
          },
          {
            path: 'settings',
            name: 'AdminOperatingCompanySettings',
            component: () => import('../views/settings/OperatingCompanySettingsDetails.vue'),

            meta: {
              backRoute: { name: 'AdminOperatingCompanyIndex' },
              resource: 'setting',
            },
          },
          {
            path: 'settings/edit_settings',
            name: 'AdminOperatingCompanySettingsEdit',
            component: () => import('../views/settings/OperatingCompanySettingsInput.vue'),
            meta: {
              action: 'edit',
              backRoute: { name: 'AdminOperatingCompanySettings' },
            },
          },
          /* ------- ADDRESSES ------- */
          {
            path: 'addresses',
            name: 'AdminOperatingCompanyAddress',
            component: {
              name: 'AdminOperatingCompanyAddress',
              render(h) {
                return h('router-view');
              },
            },
            get redirect() {
              return this.children[0];
            },
            meta: {
              backRoute: { name: 'AdminOperatingCompanyDetails' },
              resource: 'address',
            },
            children: [
              {
                path: '',
                name: 'AdminOperatingCompanyAddressIndex',
                component: () => import('../views/address/OperatingCompanyAddresses.vue'),
                meta: {
                  backRoute: { name: 'AdminOperatingCompanyDetails' },
                },
              },
              {
                path: 'new',
                name: 'AdminOperatingCompanyAddressNew',
                component: () => import('../views/address/AddressInput.vue'),
                meta: {
                  action: 'new',
                  backRoute: { name: 'AdminOperatingCompanyAddress' },
                },
              },
              {
                path: ':addressId(\\d+)',
                name: 'AdminOperatingCompanyAddressShow',
                component: () => import('../views/address/AddressShow.vue'),
                meta: {
                  backRoute: {
                    name: 'AdminOperatingCompanyAddress',
                  },
                  tArgs: route => ({ name: route.params?.addressId }),
                },
                get redirect() {
                  return this.children[0];
                },
                children: [
                  {
                    path: '',
                    name: 'AdminOperatingCompanyAddressDetails',
                    component: () => import('../views/address/AddressDetails.vue'),
                    meta: {
                      backRoute: { name: 'AdminOperatingCompanyAddressIndex' },
                    },
                  },
                  {
                    path: 'edit',
                    name: 'AdminOperatingCompanyAddressEdit',
                    component: () => import('../views/address/AddressInput.vue'),
                    meta: {
                      action: 'edit',
                      backRoute: { name: 'AdminOperatingCompanyAddressShow' },
                    },
                  },
                ]
              }
            ],
          },
        ],
      },
    ],
  },
];

OCRoutes.forEach(route => router.addRoute('OC', route));
